import { Navigate } from "react-router-dom";
import { useUser } from "../../store/auth/AuthSelectors";
import { RoleBasedAccessProps } from "./Guard.types";

export function RoleBasedAccess({
  children,
  allowedRoles,
  allowedUserIds,
  navigateTo,
}: RoleBasedAccessProps) {
  const user = useUser();
  const fallBack =
    typeof navigateTo === "string" ? <Navigate to={navigateTo} /> : null;
  if (!user) {
    return fallBack;
  }
  if (allowedUserIds !== undefined && allowedUserIds.length > 0) {
    return allowedUserIds.includes(user.id) ? <>{children}</> : fallBack;
  }
  return !allowedRoles?.length ? (
    <>{children}</>
  ) : allowedRoles?.includes(user.role) ? (
    <>{children}</>
  ) : (
    fallBack
  );
}